import { Outlet } from "react-router-dom";
import { Footer, NavBar } from "app/components";

export function AppLayout() {
  return (
    <main className="animate__animated animate__fadeIn">
      <NavBar />

      <div className="container p-2" style={{ minHeight: "100vh" }}>
        <Outlet />
      </div>

      <Footer />
    </main>
  );
}
